import React, { Component } from "react";
import Landing from "./LandingContainer";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";
// import Button from "@material-ui/core/Button";
import Warning from "@material-ui/icons/Warning";

import "./../createUserContainer.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as modalActs from "./../../Actions/Modal";
import * as actions from "./../../Actions/Dashboard";

// import DashboardIcon from "./../../images/icons/navigation/analisis.svg";

import { sendService } from "./../../Services/service";
// import { number } from "prop-types";
// import { Input, List } from "@material-ui/core";

class CreateUserContainer extends Component {
  state = {
    form: {},
    perfil: [],
    roles: []
  }

  onChangeRoute = route => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  };

  handlerChange = (variable, value) => {
    console.log(variable, value)
    this.setState({
      form: {
        ...this.state.form,
        [variable]: value
      }
    })
  }

  handlerSubmit = async () => {
    console.log(this.state.form)
    if(this.state.form.roles.length === 0){
      window.alert('Favor asigne al menos un rol')
      return
    }
    // let data = {
    //   ...this.state.form,
    // };

    this.props.modalActions.openLoader();
    let resp = await sendService("/api/v1/users/new", "POST", this.state.form);
    this.props.modalActions.closeLoader();
    this.props.modalActions.openModal(this.modal(resp.response));

    if (resp.status !== 200) {
      this.props.modalActions.openModal(<label>Hubo un error</label>)
      return false
    }

    return true
  }
  
  modal = (text, status) => {
    return (
      <>
        <div>
          <div className="modal-icon">
            <div className="center">
              <Warning />
            </div>
            ADVERTENCIA
          </div>
          <div className="modal-message">{text}</div>
          <div className="container-content">
            <Form
              onChange={this.handlerChange}
              objectCreator={[
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                },
                {
                  type: formTypes.submit,
                  classContainer: "button-primary line line-20 text-center",
                  label: "Aceprtar",
                  placeholder: "-"
                },
                {
                  type: formTypes.div,
                  classContainer: "line line-40"
                }
              ]}
              onSubmit={this.closeModal}
            />
          </div>
        </div>
      </>
    );
  };
  async componentWillMount() {
    const roles = await sendService('/api/v1/users/getRoles', 'GET')
    this.setState({ roles: roles.status === 200 ? roles.response : [] })
  }

  userCreated = () => {
    this.props.modalActions.closeModal()
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={true}>
        <>
          <div>
            <h1 className="page-title">{LANDING_MENU_BAR.CREATE_USER}</h1>
          </div>
          <div className="">
            <div className="background-body">
              <div className="container-content">
                <div className="content-line white-bg">
                  <Form
                    // onReset={this.handleFormReset}
                    onChange={this.handlerChange}
                    objectCreator={[
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Nombre(s)",
                        placeholder: "Ingrese su(s) nombre(s)",
                        required: true,
                        variable: "nombres",
                        value: ""
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Apellidos",
                        placeholder: "Ingrese sus apellidos",
                        required: true,
                        variable: "apellidos",
                        value: ""
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Cargo",
                        placeholder: "Ingrese el cargo del usuario",
                        required: true,
                        variable: "cargo",
                        value: ""
                      },
                      {
                        type: formTypes.select,
                        label: "Tipo de documento",
                        // placeholder: "Seleccione el tipo de documento",
                        required: true,
                        classContainer: "line line-33",
                        classLabel: "input-text",
                        // classInput: "form-control",
                        variable: "tipoDocumento",
                        keyValue: "text",
                        keyText: "text",
                        data: [
                          { value: "Contraseña", text: "Contraseña" },
                          { value: "Cédula de ciudadanía", text: "Cédula de ciudadanía" },
                          { value: "Tarjeta de identidad", text: "Tarjeta de identidad" },
                          { value: "Cedula de extranjería", text: "Cedula de extranjería" },
                          { value: "Pasaporte", text: "Pasaporte" }
                        ],
                        value: ["Contraseña"],
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Número de documento",
                        placeholder: "Ingrese número de documento",
                        required: true,
                        variable: "numeroDocumento",
                        value: ''
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Dependencia",
                        placeholder: "Ingrese dependencia",
                        required: true,
                        variable: "dependencia",
                        value: ""
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        isEmail: true,
                        notEmail: false,
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Usuario",
                        placeholder: "Ingrese nombre de usuario",
                        required: true,
                        variable: "user",
                        value: ""
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        isEmail: true,
                        notEmail: false,
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Correo electrónico",
                        placeholder: "Ingrese correo electrónico",
                        required: true,
                        variable: "correo",
                        value: ""
                      },
                      {
                        type: formTypes.password,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Contraseña",
                        placeholder: "Ingrese su contraseña",
                        required: true,
                        variable: "password",
                        viewPassword: true,
                        value: ""
                      },
                      {
                        type: formTypes.password,
                        classContainer: "line line-33",
                        equalTo: "password",
                        notValidated: false,
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "Confirmar contraseña",
                        placeholder: "Confirme su contraseña",
                        required: true,
                        // value: '',
                        variable: "confirmPassword",
                        viewPassword: true,
                        value: ""
                      },
                      {
                        type: formTypes.text,
                        classContainer: "line line-33",
                        // classInput: "form-control",
                        classLabel: "input-text",
                        label: "¿Nombre de quién autoriza el registro?",
                        placeholder: "Ingrese nombre completo",
                        required: true,
                        variable: "nombreAutorizaRegistro",
                        value: '',
                      },
                      {
                        type: formTypes.checkbox,
                        classContainer: "line line-100",
                        classInput: "secondary-color",
                        classLabel: "input-text line line-33 align-cb",
                        checkMark: "checkmark",
                        data: this.state.roles,
                        keyText: "rol",
                        keyValue: "id",
                        label: "Rol(es) asignado(s)",
                        required: true,
                        variable: "roles",
                        value: []
                      },
                      {
                        type: formTypes.div,
                        classContainer: "line line-40"
                      },
                      {
                        type: formTypes.submit,
                        classContainer:
                          "button-primary line line-10 text-center",
                        label: "Guardar",
                        placeholder: "-"
                      },
                      {
                        type: formTypes.click,
                        classContainer:
                          "button-secondary line line-10 text-center",
                        label: "Cancelar",
                        placeholder: "-",
                        onClick: () => this.onChangeRoute('/Administrar-usuario')
                      },
                      {
                        type: formTypes.div,
                        classContainer: "line line-40"
                      }
                    ]}
                    onSubmit={this.handlerSubmit}
                    values={this.state.form}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      </Landing>
    );
  }
}

// export default CreateUserContainer;
function mapStateToProps(state) {
  return {
    session: state.session
    // open: state.modal.open,
    // children: state.modal.children
  };
}

function mapDispatchToProps(dispatch) {
  return {
    modalActions: bindActionCreators(modalActs, dispatch),
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateUserContainer);
